import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  promotionDetails: [],
  isLoading: false,
  error: "",
  hasData: false
};
const offersAndPromotionSlice = createSlice({
  name: "offersAndPromotion",
  initialState,
  reducers: {
    offersAndPromotionDataRequest: state => {
      state.isLoading = true;
    },
    getoffersAndPromotionDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.promotionDetails = action.payload;
    },
    getoffersAndPromotionDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});
export const {
  offersAndPromotionDataRequest,
  getoffersAndPromotionDataSuccess,
  getoffersAndPromotionDataFailure
} = offersAndPromotionSlice.actions;
export default offersAndPromotionSlice.reducer;